const AGENCIES = {
    AMAZING_CARE: 34,
    ST_CROIX_HOSPICE: 25,
    HOME_HEALTH_COMPANIONS: 2,
    RENEWAL_MEMORY_PARTNERS: 23,
    DEMO: 1,
    AMERIBEST_HOME_CARE: 9,
    AMERIBEST: 3,
    TEST: 8,
    ROYAL_HOME_CARE: 7, 
    SUNSHINE_HOME_CARE: 19,
    LEGACY_HOSPICE: 69,
    LEVO_CAREGIVER_AMBASSADOR: 24,
    ALLIANCE_HOME_CARE: 15,
    COLLAGE_REHAB: 22,
    LEVO_HIRING_DEMO: 26,
    VNA_HEALTH: 72,
    AGAPE_CARE_GROUP: 30,
    HELPING_HANDS_FAMILY: 32,
    COMFORT_KEEPERS: 31,
    LIFECARE: 73,
    LEVO: 71,
    GRAHAM_HEALTHCARE_GROUP: 36,
    COMFORT_KEEPERS_CENTRAL_OHIO: 35,
    HEALTHPRO_HERITAGE: 33,
    BESTCARE: 20,
    SUMA_HOME_CARE: 17,
    HARBOR_CARE: 21,
    WESTCHESTER_FAMILY_CARE: 10,
    LONGEVITY_CARE: 27,
    CAREGIVER_IDD: 70
  };

  export const AGENCIES_WITH_EXIT_SURVEY = [AGENCIES.ST_CROIX_HOSPICE];

  export const GRAHAM_HEALTHCARE_GROUP_ID = AGENCIES.GRAHAM_HEALTHCARE_GROUP;

  